import Vue from 'vue';
import Router from 'vue-router';
import Dashboard from "../views/Dashboard";
import Profile from "../views/Profile";
import NotFound from "../views/NotFound";
import Login from "../views/Login";
import Invoicing from "../modules/invoices";
import Magazine from "../modules/magazine";
import Logout from "../views/Logout";
import Registration from "../views/Register"
import store from "../store";

Vue.use(Router);

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '*',
            name: 'Error page',
            component: NotFound,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/',
            name: 'Dashboard',
            component: Dashboard,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/profile',
            name: 'Profile',
            component: Profile,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/invoicing',
            name: 'Invoicing',
            component: Invoicing,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/magazine',
            name: 'Magazine',
            component: Magazine,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/login',
            name: 'Login',
            component: Login,
            meta: {
                requiresAuth: false
            }
        },
        {
            path: '/logout',
            name: 'Logout',
            component: Logout,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/registration',
            name: 'New user registration',
            component: Registration
        }
    ],

});

router.beforeEach((to, from, next) => {

    if (to.matched.some(record => record.meta.requiresAuth)) {

        if (!store.getters.loggedIn) {
            next({
                name: 'Login'
            })
        } else {
            store.commit('updatePageTitle', to.name)
            next()
        }
    } else {
        next()
    }
})

export default router
